import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const AcademyService = sdk.getService('AcademyService');

export const useAcademy = (academyId?: string) => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['academy', academyId],
    queryFn: () => AcademyService.getAcademy(academyId as string),
    enabled: Boolean(academyId),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false
  });

  return {
    isLoading,
    academy: data,
    error
  };
};
